<template>
	<Modals
		:display="display"
		:parentTag="'form'"
		:novalidate="'novalidate'"
		:fullMobile="true"
		:title="title"
		@show="close"
	>
		<template #modal-content>
			<p>{{ actionDetails }}</p>
			<Table
				:sourceObject="formLogData"
				:tableMobilev1="true"
				:paginationFeature="true"
				@change="updatePagination"
			>
				<template #body-ChangedPropertyName="{ body }">
					<span v-html="formatPropertyName(body)" />
				</template>
				<template #body-OriginalValue="{ body }">
					<span
						v-html="formatOriginalValue(body)"
						data-test="originalValue"
					/>
				</template>
				<template #body-NewValue="{ body }">
					<span v-html="formatNewValue(body)" data-test="newValue" />
				</template>
			</Table>
		</template>
		<template #modal-footer>
			<Button
				id="linkButton"
				className="btn--primary"
				labelText="Close"
				:btnClick="close"
			/>
		</template>
	</Modals>
</template>

<script>
import Modals from '@/components/shells/modal/modals';
import Button from '@/components/forms/button/button';
import Table from '@/components/shells/table/table';
import DateTimeMixin from '@/mixins/datetime-mixin';
import HistoryHelpers from '@/mixins/history-helpers';

export default {
	name: 'LogHistoryDetailModal',
	components: {
		Modals,
		Button,
		Table
	},
	model: {
		prop: 'display',
		event: 'close'
	},
	props: {
		title: {
			type: String,
			default: ''
		},
		display: {
			type: Boolean,
			default: false
		},
		parentTag: {
			type: String,
			default: 'div'
		},
		validateBeforeClose: {
			type: Boolean,
			default: false
		},
		logs: {
			type: Object,
			default: () => {}
		}
	},
	mixins: [HistoryHelpers, DateTimeMixin],
	data() {
		return {
			showModal: this.display,
			formLogData: {}
		};
	},
	created() {
		this.formLogData = {
			headers: [
				{
					key: 'ChangedPropertyName',
					label: 'Changed Property',
					sorteable: false
				},
				{
					key: 'OriginalValue',
					label: 'Original Value',
					sorteable: false
				},
				{
					key: 'NewValue',
					label: 'New Value',
					sorteable: false
				}
			],
			displayHeader: true,
			source: { items: [...this.logs.fieldChanges.items] }
		};

		this.updatePagination({ page: 1, pageSize: 5 });
	},
	methods: {
		formatPropertyName(data) {
			let name = data.ChangedPropertyName;

			if (data.Action === 'Update') {
				if (name.indexOf('.') !== -1) {
					const matchWithAttr = name.match(/[^.]+$/);

					name = this.removeAttrPropName(name);

					if (matchWithAttr) {
						return `
						<p><strong>${name}</strong></p>
						<span>${matchWithAttr[0]}</span>
						`;
					}
				}
			}

			return `<strong> ${this.removeIdPropName(
				data.ChangedPropertyName
			)}</strong>`;
		},
		close() {
			this.$emit('close', false);
		}
	}
};
</script>

<style lang="scss">
/**
    * [Description]
    *
    * Vendors History Logs Form Modal
    * Can use SCSS variables = TRUE
    *
**/

.vendors-history-logs {
	@include mq($from: md) {
		width: 85vw;
	}

	@include mq($from: md-l) {
		width: 75vw;
		max-width: 840px;
	}

	&__updated-by {
		@include body-text('sm-supporting');
		margin-bottom: $gutter-lg;
	}

	&__data {
		@include body-text('regular-emphasis');
	}
}

.table-data-deleted {
	color: $ui-negative;
}

/*------------------------------------*\
  Vendors History Table
\*------------------------------------*/

.table-container--vendors-history-logs {
	.table {
		@include mq($from: md) {
			table-layout: fixed;
		}
	}
	.table__col {
		@include mq($from: md) {
			&--property,
			&--original-value,
			&--new-value {
				width: 85px;
			}
		}
	}
	margin-bottom: $gutter-lg;
}
</style>
